import { useSelector } from 'react-redux'
import { RootState } from '../../../redux'
import { ArrowRightIcon } from './ArrowRightIcon'

export const StepsIndicator = () => {
  const { step } = useSelector((state: RootState) => state.ivyLeague)
  return (
    <div className="stepsIndicatorContainer">
      <div className={`step ${step >= 1 ? 'selectedStep' : ''}`}>
        <div className="stepNumber" style={{ backgroundColor: step >= 1 ? '#096839' : '#adaeb6' }}>1</div>
        <div className="stepName">Parent Information</div>
        <ArrowRightIcon isCurrentStep={step >= 1} />
      </div>
      <div className={`step ${step >= 2 ? 'selectedStep' : ''}`}>
        <div className="stepNumber" style={{ backgroundColor: step >= 2 ? '#096839' : '#adaeb6' }}>2</div>
        <div className="stepName">Sessions</div>
        <ArrowRightIcon isCurrentStep={step >= 2} />
      </div>
      <div className={`step ${step >= 3 ? 'selectedStep' : ''}`}>
        <div className="stepNumber" style={{ backgroundColor: step >= 3 ? '#096839' : '#adaeb6' }}>3</div>
        <div className="stepName">Discounts</div>
        <ArrowRightIcon isCurrentStep={step >= 3} />
      </div>
      <div className={`step ${step >= 4 ? 'selectedStep' : ''}`}>
        <div className="stepNumber" style={{ backgroundColor: step >= 4 ? '#096839' : '#adaeb6' }}>4</div>
        <div className="stepName">Summary</div>
      </div>
    </div>
  )
}
